import { ACCEPTED_FILE_TYPES, MAX_UPLOAD_BYTES } from '@/constants/upload';
import { env } from '@/config/env';

export interface FileValidationResult {
  valid: boolean;
  error?: string;
}

export function validateUploadFile(file: File): FileValidationResult {
  const isAcceptedType = Object.prototype.hasOwnProperty.call(ACCEPTED_FILE_TYPES, file.type);

  if (!isAcceptedType) {
    return {
      valid: false,
      error: 'Unsupported file type. Please upload a PDF, Word, JPG or PNG file.',
    };
  }

  if (file.size > MAX_UPLOAD_BYTES) {
    return {
      valid: false,
      error: `File is too large. Maximum allowed size is ${env.maxUploadMb} MB.`,
    };
  }

  if (file.size === 0) {
    return { valid: false, error: 'This file appears to be empty.' };
  }

  return { valid: true };
}

export function getFileTypeLabel(mimeType: string): string {
  return ACCEPTED_FILE_TYPES[mimeType] ?? 'FILE';
}
